<span class="expand-icon" (click)="openModal()" (keydown)="openModal()">
  <span class="expand-label">{{ label }}</span>
  <hdi-icon
    [iconName]="expandIconType"
    [iconPrefix]="'far'"
    [size]="sizeIcon"
    [color]="colorIcon"
    [disabled]="disabledState"
  ></hdi-icon>
</span>

<!-- Modal Overlay -->
<hdi-modal [showModal]="showModal" (closeModalTrigger)="showModal = $event">
  <ng-content></ng-content>
</hdi-modal>
